
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/free-depression-test",
      function () {
        return require("private-next-pages/free-depression-test.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/free-depression-test"])
      });
    }
  